import { Api } from "../../api/Api";
import { BooleanThunk, BooleanThunkAction } from "../IStore";
import { CardDesignDto } from "../models/carddesign/CardDesignDto";
import { thunkCreateErrorNotification, thunkCreateSuccessNotification } from "./NotificationActions";

export const GET_ALL_CARD_DESIGNS = "GET_ALL_CARD_DESIGNS";
export const DELETE_CARD_DESIGN = "DELETE_CARD_DESIGN";

export const thunkGetAllCardDesigns = (): BooleanThunk => async (dispatch) => {
  try {
    const cardDesigns = await Api.getAllCardDesigns();
    dispatch({
      type: GET_ALL_CARD_DESIGNS,
      payload: cardDesigns,
    });
    return true;
  } catch (e) {
    dispatch(thunkCreateErrorNotification("Failed to load passes", e));
    return false;
  }
};

export const thunkCreateCardDesign =
  (cardDesign: CardDesignDto): BooleanThunk =>
  async (dispatch) => {
    try {
      await Api.createCardDesign(cardDesign);
      dispatch(thunkGetAllCardDesigns() as BooleanThunkAction);
      dispatch(thunkCreateSuccessNotification("Der Pass wurde angelegt"));
      return true;
    } catch (e) {
      dispatch(thunkCreateErrorNotification("Failed to create pass", e));
      return false;
    }
  };

export const thunkUpdateCardDesign =
  (cardDesign: CardDesignDto): BooleanThunk =>
  async (dispatch) => {
    try {
      await Api.updateCardDesign(cardDesign);
      dispatch(thunkGetAllCardDesigns() as BooleanThunkAction);
      dispatch(thunkCreateSuccessNotification("Der Pass wurde aktualisiert"));
      return true;
    } catch (e) {
      dispatch(thunkCreateErrorNotification("Failed to update the pass", e));
      return false;
    }
  };

export const thunkDeleteCardDesign =
  (cardDesign: CardDesignDto): BooleanThunk =>
  async (dispatch) => {
    try {
      await Api.deleteCardDesign(cardDesign);
      dispatch({
        type: DELETE_CARD_DESIGN,
        payload: cardDesign,
      });
      dispatch(thunkCreateSuccessNotification("Der Pass wurde gelöscht"));
      return true;
    } catch (e) {
      if (e === "The Default Identification is not deletable!") {
        dispatch(
          thunkCreateErrorNotification("The pass cannot be deleted - The standard pass must not be deleted.", e)
        );
      } else if (e === "Identification in use by Customer.") {
        dispatch(
          thunkCreateErrorNotification("The pass cannot be deleted - There are still members assigned to this pass.", e)
        );
      } else if (e === "Identification in use by Bonus Rule.") {
        dispatch(
          thunkCreateErrorNotification(
            "The pass cannot be deleted - There are still bonus rules associated with this pass.",
            e
          )
        );
      } else {
        dispatch(thunkCreateErrorNotification("Failed to delete the pass", e));
      }
    }
    return false;
  };
